import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {reduxForm} from 'redux-form/immutable';

import {InputField} from 'common/fields';
import {TextAreaField} from 'common/fields';

const validate = input => {
	const errors = {};
	if (!input.get('message')) {
		errors.message = 'Введите сообщение';
	}
	return errors;
};

@reduxForm({
	form: 'bookForm',
	validate,
	enableReinitialize: true,
})
export default class extends Component {
	static propTypes = {
		loading: PropTypes.bool,
		like: PropTypes.bool,
		handleSubmit: PropTypes.func,
		error: PropTypes.string,
	};

	render() {
		const {
			like,
			error,
			loading,
			handleSubmit,
		} = this.props;

		return (
			<form onSubmit={handleSubmit}>
				<div className="form">
					<div className="form-group">
						<label htmlFor="field-name">Ваше имя <span>(не обязательно)</span></label>
						<InputField
							id="field-name"
							name="name"
							type="text"
							className="form-control"
						/>
					</div>
					<div className="form-group">
						<label htmlFor="field-card">Номер телефона <span>(не обязательно)</span></label>
						<InputField
							id="field-phone"
							name="phone"
							type="text"
							className="form-control"
						/>
					</div>
					<div className="form-group">
						<label htmlFor="field-message">
							{like ? 'Ваше сообщение' : 'Опишите проблему'}
						</label>
						<TextAreaField
							id="field-message"
							name="message"
							className="form-control"
						/>
					</div>
					<div className="form-group">
						<input
							type="submit"
							className="btn btn-default"
							value="Отправить"
							disabled={loading}
						/>
					</div>
				</div>
				{error && (
					<div className="text-center text-danger">{error}</div>
				)}
			</form>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/review/FormComponent.js